import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import moment from 'moment';
import { useManipulateCalendarType } from '../../../../../../hooks/component/sKPI/useOfSidePanelAddDataserieVariableValue';
import CLabel from '../../../../../Common/CLabel';
import { Dropdown, TagPicker } from '@fluentui/react';
import { useGetBoardElementDataserieValue, useGetDataSerieValues } from '../../../../../../hooks/services/sKPI/useOfBoard';
import { __HoursValues, __MessageTypes, __ShiftValues, enum__PRIVILEGES } from '../../../../../../common/Dictionaries';
import CCurrencyTextBox from '../../../../../Common/CCurrencyTextBox';
import { __OBJECT_STRUCTURE_GetDataserieValue } from '../../../../../../common/ObjectStructures/sKPI';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import List from '../../../../../Templates/List';
import { useContext } from 'react';
import MainAppContext from '../../../../../../MainAppContext';
import { useGetDataSerieValue } from '../../../../../../hooks/services/sKPI/useOfDataSerie';
import ListPagination from '../../../../../Templates/List/ListPagination';
import { deleteDataserievalue } from '../../../../../../services/sKPI/board.service';
import PropTypes from 'prop-types';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { checkIfDataserieValueEditDeleteMode, isNullUndefined, showMessage } from '../../../../../../common/Helpers';
import { action_setBoardViewVariableDataserieValues } from '../../../../../../reducers/actions/KPI/actions';
import { useDispatch } from 'react-redux';
import { getBoardVariableDataSerieValues } from '../../../../../../services/sKPI/dataserie.service';
import BoardAppContext from '../../../../../../BoardAppContext';
import { _checkSecurityUser } from '../../../../../../common/Helpers/HLP_Security';

function manipulateSerieTimeAsDateTime(measurementTypeId, serieTime) {

    serieTime = serieTime.toString();

    let serieTimeDate = null;
    let year = null;
    let month = null;
    let day = null;
    let hour = null;
    let shift = null;

    switch (measurementTypeId) {
        case "decade":
            year = serieTime.slice(0, 4);

            serieTimeDate = new Date(year, 0, 1, 0, 0, 0, 1)
            break;
        case "year":
            year = serieTime.slice(0, 4);
            month = serieTime.slice(4, 6) -1;

            serieTimeDate = new Date(year, month, 1, 0, 0, 0, 0, 1)
            break;
        case "month":
            year = serieTime.slice(0, 4);
            month = serieTime.slice(4, 6) -1;
            day = serieTime.slice(6, 8);

            serieTimeDate = new Date(year, month, day, 0, 0, 0, 1)
            break;
        case "hour":
            year = serieTime.slice(0, 4);
            month = serieTime.slice(4, 6) -1;
            day = serieTime.slice(6, 8);
            hour = serieTime.slice(8, 10);

            serieTimeDate = new Date(year, month, day, hour, 0, 0, 1)
            break;
        case "shift":
            year = serieTime.slice(0, 4);
            month = serieTime.slice(4, 6) -1;
            day = serieTime.slice(6, 8);
            shift = serieTime.slice(8, 9);

            serieTimeDate = new Date(year, month, day, shift, 0, 0, 1)
            break;                  
        default:
            break;
    }

    return serieTimeDate;
}
const SidePanelDeleteDataserieVariableValue = (props) => {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);

    const dispatch = useDispatch();

    const { 
        inputParam_BoardId = null,
        inputParam_ElementId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_DataSerie = null,
        inputParam_ElementType = null,
        setBoardVariableDataserieValues = null,
        inputParam_UserProps = null,
    } = props;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });


    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [showFinishButton, setShowFinishButton] = useState(false);

    const [dataserievalueList, setDataserievalueList] = useState(__OBJECT_STRUCTURE_GetList());
    useGetDataSerieValues(inputParam_BoardId, inputParam_DataSerie.elementId, inputParam_DataSerie.dataserieId, contextSite.kpiModule.boardCalendarFilterConfig.value, dataserievalueList, setDataserievalueList, inputParam_IsPanelOpen)
    
    const [objDataserieValue, setObjDataserieValue] = useState(__OBJECT_STRUCTURE_GetDataserieValue(null));
    useGetBoardElementDataserieValue(objDataserieValue, setObjDataserieValue, inputParam_DataSerie.dataserieId, inputParam_IsPanelOpen)
    
    const [fireGetDeleteElement, setFireGetDeleteElement] = useState({fire : false, dataserieValueId: null, serieTime: null});  
    useGetDataSerieValue(objDataserieValue, setObjDataserieValue, inputParam_DataSerie.dataserieId, fireGetDeleteElement.dataserieValueId, fireGetDeleteElement.serieTime, inputParam_IsPanelOpen, fireGetDeleteElement.fire, setFireGetDeleteElement)

    const aux_userProps = !isNullUndefined(inputParam_UserProps) ? inputParam_UserProps : contextBoard.userPropsKpi.value;

    const editMode = checkIfDataserieValueEditDeleteMode(objDataserieValue)
    const _priv_canDelete = editMode ? _checkSecurityUser(contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.KPI_CONTRACT_VALIDATE): editMode;
    //const _priv_canDelete = _checkSecurityUser(contextSite.onlyObserver, contextBoard.userPropsKpi.value, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.KPI_CONTRACT_VALIDATE);

    const [calendarConfig, setCalendarConfig] = useState({
        maxDetail:null,//decade, year, month
        minDetail:"century",
        selectRange:false,
        showDoubleView:false,
        returnValue:"start"
    });
    useManipulateCalendarType(calendarConfig, setCalendarConfig, inputParam_ElementType, inputParam_IsPanelOpen, inputParam_DataSerie.measurementPeriodId, setObjDataserieValue)
  
    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = async () => {
        showMessage(setMessageConfig, false, null, null)
        setObjDataserieValue(__OBJECT_STRUCTURE_GetDataserieValue(null));
        setDataserievalueList(__OBJECT_STRUCTURE_GetList())

        if (inputParam_ElementId !== null) {
            const startDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate !== null ? moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('MM/DD/YYYY') : null;
            const endDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate !== null ? moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate).format('MM/DD/YYYY') : null;
        
            const elementDataserieResponse = await getBoardVariableDataSerieValues(
                inputParam_BoardId,
                inputParam_ElementId,
                null,
                contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId,
                contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId,
                startDate,
                endDate
            );
            
            if (elementDataserieResponse.data.succeeded) {
                dispatch(action_setBoardViewVariableDataserieValues(elementDataserieResponse.data.data))
            }
        }

        inputParam_SetterIsPanelOpen(false);
    };

    
    const onDeleteFromListClick = (item) => {
        setFireGetDeleteElement({
            fire : true,
            dataserieValueId : item.id,
            serieTime: moment(manipulateSerieTimeAsDateTime(inputParam_ElementType, item.serieTime)).format('MM/DD/YYYY')
        })

        setShowDeleteForm(true)
    };

    const onDeleteItem = () => {
        deleteDataserievalue(objDataserieValue.id).then((response) => {
            if (response.data.succeeded) {
                let itemList = [ ...dataserievalueList.data ]
                itemList = itemList.filter(x => x.id !== objDataserieValue.id);
                setDataserievalueList(prevState => ({
                    ...prevState,
                    fireUpdate:true,
                    data: itemList
                }));

                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    
                !showFinishButton && setShowFinishButton(true)
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }

            setShowDeleteForm(false)
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    };

    const onRebindDataserieValueList = () => {
        setShowDeleteForm(false);
    }
    
    const onSelectionChange = (selectedValues) => {
        let aux_value =  selectedValues.length > 0 ? selectedValues[0].key : null;
        let aux_serieTime = objDataserieValue.serieTime;
        
        aux_serieTime = (aux_value !== null) ? aux_serieTime.setHours(aux_value, 0, 0, 0) : aux_serieTime.setHours(0, 0, 0, 1);

        setObjDataserieValue(prevState => ({
            ...prevState,  
            serieTime: aux_serieTime,
            wildcard : aux_value,
        }));
    };

    const onShiftChange = (option, index) => {
        let aux_value =  option.key;
        let aux_serieTime = objDataserieValue.serieTime;
        
        aux_serieTime = aux_serieTime.setHours(aux_value, 0, 0, 0);

        setObjDataserieValue(prevState => ({
            ...prevState,  
            serieTime: aux_serieTime,
            wildcard : aux_value,
        }));
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        setBoardVariableDataserieValues && setBoardVariableDataserieValues(null)
        contextSite.kpiModule.boardCalendarFilterConfig.setter(prevState => ({
            ...prevState,
            fireFilter: true
        }))
        
        onDismissPanel();

        window.location.href = window.location.href;
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        {
                            dataserievalueList.data !== null &&
                            <ListPagination
                                listLocalStoragePageSizeVariableName="dataserieValueEditPanel"
                                data={ dataserievalueList }
                                setData={ setDataserievalueList }
                            />
                        }
                    </Col>
                    <Col xl={12}>
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            (objDataserieValue.id !== null && objDataserieValue.id !== 0 && _priv_canDelete && showDeleteForm) &&
                            <PrimaryButton onClick={ onDeleteItem } styles={_global_buttonStyles}>{ t('data-lang-btn-delete') }</PrimaryButton>
                        }
                        {
                            showFinishButton &&
                            <PrimaryButton onClick={ onClosePanel } styles={_global_buttonStyles}>{ t('data-lang-btn-finish') }</PrimaryButton>
                        }
                        {
                            !showDeleteForm && !showFinishButton &&
                            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                        }
                        {
                            showDeleteForm &&
                            <DefaultButton onClick={ () => onRebindDataserieValueList() }>{ t('data-lang-btn-backtolist') }</DefaultButton>
                        }
                    </Col>
                </Row>
    }

    const testTags = __HoursValues.map(item => ({ key: item.key, name: item.value }));
      
    const listContainsTagList = (tag, tagList) => {
        if (!tagList || !tagList.length || tagList.length === 0) {
            return false;
        }
        return tagList.some(compareTag => compareTag.key === tag.key);
    };

    const filterSuggestedTags = (filterText, tagList) => {
        return filterText
            ? testTags.filter(
                tag => tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 && !listContainsTagList(tag, tagList),
            )
        : [];
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-deletedataserievalue') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                    showDeleteForm &&
                    <>
                        <Row className="pt-3">
                            <Col>
                                <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-variablename') } labelValue={ inputParam_DataSerie.name }  />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-measurementunit') } labelValue={ inputParam_DataSerie.um }  />
                            </Col>
                        </Row>
                        <Row className="pt-5">
                            <Col>
                                <h6><CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-dataserievalues') } labelValue={ null }  /></h6>
                            </Col>
                        </Row>
                        {
                            objDataserieValue.id !== null &&
                            <Row className="pt-3">
                                <Col>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-period') } labelValue={ objDataserieValue.serieTime !== null ? moment(objDataserieValue.serieTime).format('DD/MM/YYYY') : "Select an element to edit." }  />
                                </Col>
                            </Row>
                        }
                        {
                            inputParam_DataSerie.measurementPeriodId === 5 &&
                            <Row className="pt-3">
                                <Col xl={6}>
                                    <Dropdown
                                        placeholder="Turno"
                                        label="Turno"
                                        options={__ShiftValues}
                                        styles={{ width: 50 }}
                                        onChange={onShiftChange}
                                    />
                                </Col>
                            </Row>
                        }
                        {
                            inputParam_DataSerie.measurementPeriodId === 4 &&
                            <Row className="pt-3">
                                <Col xl={6}>
                                    <label className='ms-Label custom-txt-root'>{t('data-lang-lbl-hour')}</label>
                                    <TagPicker
                                        removeButtonAriaLabel="Remove"
                                        selectionAriaLabel={t('data-lang-lbl-selectedhour')}
                                        onResolveSuggestions={filterSuggestedTags}
                                        getTextFromItem={(item) => item.name}
                                        pickerSuggestionsProps={{
                                            suggestionsHeaderText: t('data-lang-lbl-suggestedhour'),
                                            noResultsFoundText: t('data-lang-lbl-hournotfound'),
                                        }}
                                        itemLimit={1}
                                        defaultSelectedItems={objDataserieValue.wildcard !== null ? [testTags.find(x => x.key === objDataserieValue.wildcard)] : []}
                                        onChange={onSelectionChange}
                                        pickerCalloutProps={{ doNotLayer: true }}
                                    />
                                </Col>
                            </Row>
                        }
                        {
                            inputParam_DataSerie.useOfVariables &&
                            <Row className="py-3 mt-3 border rounded-1">
                                <Col xl={12}>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-formula')} labelValue={objDataserieValue.formulaDesc}  />
                                </Col>
                                <Col xl={6}>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-k1')} labelValue={objDataserieValue.k1}  />
                                </Col>
                                <Col xl={6}>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-k2')} labelValue={objDataserieValue.k2}  />
                                </Col>
                                <Col xl={6}>
                                    <CCurrencyTextBox
                                        labelText={t('data-lang-lbl-field-v1')}
                                        controlValue={objDataserieValue.v1}
                                        objectPropertyNameForSetter={"v1"}
                                        setterIsPropertyObject={true}
                                        setterControlValue={setObjDataserieValue}
                                        object={objDataserieValue}
                                        disabled={true}
                                    />
                                </Col>
                                <Col xl={6}>
                                    <CCurrencyTextBox
                                        labelText={t('data-lang-lbl-field-v2')}
                                        controlValue={objDataserieValue.v2}
                                        objectPropertyNameForSetter={"v2"}
                                        setterIsPropertyObject={true}
                                        setterControlValue={setObjDataserieValue}
                                        object={objDataserieValue}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                        }
                        <Row className="pt-3">
                            <Col>
                                <CCurrencyTextBox
                                    labelText={t('data-lang-lbl-field-valueReal')}
                                    controlValue={objDataserieValue.valueReal}
                                    objectPropertyNameForSetter={"valueReal"}
                                    setterIsPropertyObject={true}
                                    setterControlValue={setObjDataserieValue}
                                    object={objDataserieValue}
                                    disabled={true}
                                />
                            </Col>
                            <Col>
                                <CCurrencyTextBox
                                    labelText={t('data-lang-lbl-field-valueProvisory')}
                                    controlValue={objDataserieValue.valueProvisory}
                                    objectPropertyNameForSetter={"valueProvisory"}
                                    setterIsPropertyObject={true}
                                    setterControlValue={setObjDataserieValue}
                                    object={objDataserieValue}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <CCurrencyTextBox
                                    labelText={t('data-lang-lbl-field-valueBudget')}
                                    controlValue={objDataserieValue.valueBudget}
                                    objectPropertyNameForSetter={"valueBudget"}
                                    setterIsPropertyObject={true}
                                    setterControlValue={setObjDataserieValue}
                                    object={objDataserieValue}
                                    disabled={true}
                                />
                            </Col>
                            <Col>
                                <CCurrencyTextBox
                                    labelText={t('data-lang-lbl-field-valueForecast')}
                                    controlValue={objDataserieValue.valueForecast}
                                    objectPropertyNameForSetter={"valueForecast"}
                                    setterIsPropertyObject={true}
                                    setterControlValue={setObjDataserieValue}
                                    object={objDataserieValue}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <CCurrencyTextBox
                                    labelText={t('data-lang-lbl-field-valueGoal')}
                                    controlValue={objDataserieValue.valueGoal}
                                    objectPropertyNameForSetter={"valueGoal"}
                                    setterIsPropertyObject={true}
                                    setterControlValue={setObjDataserieValue}
                                    object={objDataserieValue}
                                    disabled={true}
                                />
                            </Col>
                            {
                                objDataserieValue.id !== 0 && objDataserieValue.id !== null &&
                                <Col>
                                    <CCurrencyTextBox
                                        labelText={t('data-lang-lbl-field-valueGoalPercent')}
                                        controlValue={objDataserieValue.valueGoalPercent}
                                        objectPropertyNameForSetter={"valueGoalPercent"}
                                        setterIsPropertyObject={true}
                                        setterControlValue={setObjDataserieValue}
                                        object={objDataserieValue}
                                        disabled={true}
                                    />
                                </Col>
                            }
                        </Row>
                    </>
                }


                <Row className="pt-3" style={{display: showDeleteForm ? "none" : "unset"}}>
                    <Col xl={12}>
                        <List
                            listLocalStoragePageSizeVariableName="partyCreationUsers"
                            manipulateLocalData={ true }
                            setData={setDataserievalueList}
                            showHeaders={false}
                            data={dataserievalueList}
                            columns={[
                                {
                                    key: 'serieTime',
                                    name: t('data-lang-lbl-field-serieTime'),
                                    fieldName: 'serieTime',
                                    minWidth: 105,
                                    maxWidth: 105,
                                    onRender:(item) => {
                                        return <div>{ item.serieTime }</div>
                                    }
                                },
                                {
                                    key: 'displayValue',
                                    name: t('data-lang-lbl-field-displayValue'),
                                    fieldName: 'displayValue',
                                    minWidth: 105,
                                    maxWidth: 105,
                                    onRender:(item) => {
                                        return <div>{ item.displayValue }</div>
                                    }
                                },
                                {
                                    key: 'valueGoal',
                                    name: t('data-lang-lbl-field-valueGoal'),
                                    fieldName: 'valueGoal',
                                    minWidth: 105,
                                    maxWidth: 105,
                                    onRender:(item) => {
                                        return <div>{ item.valueGoal }</div>
                                    }
                                },
                                {
                                    key: 'valueGoalPercent',
                                    name: t('data-lang-lbl-field-valueGoalPercent'),
                                    fieldName: 'valueGoalPercent',
                                    minWidth: 105,
                                    maxWidth: 105,
                                    onRender:(item) => {
                                        return <div>{ item.valueGoalPercent }</div>
                                    }
                                },
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'id',
                                    minWidth: 30,
                                    maxWidth: 30,
                                    onRender:(item, row) => {
                                        return  <>
                                                    <ActionButton id={`btnMantDelete${item.id}`} iconProps={{ iconName: 'View' }} onClick={() => onDeleteFromListClick(item)} allowDisabledFocus />
                                                </>
                                    }
                                }
                            ]}
                        />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelDeleteDataserieVariableValue.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_DataSerie: PropTypes.object.isRequired,
    inputParam_ElementType: PropTypes.string.isRequired,
};

export default SidePanelDeleteDataserieVariableValue;